import { useMatch, useNavigate } from 'react-router-dom';

import { Modal } from '@/components/shared/modal';
import { CreateRestaurantEmployeeForm } from '@/components/restaurant/employees/create-restaurant-employee-form';
import { useTranslation } from 'react-i18next';

export const CreateRestaurantEmployeeModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const closeModal = () => navigate('/restaurant/employees', { replace: true });

  const isModalOpen = Boolean(
    useMatch({ path: '/restaurant/employees/create' }),
  );

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('restaurant-employee.create')}
      description={t('restaurant-employee.create-details')}
      className="flex flex-col px-6 overflow-y-hidden"
    >
      <CreateRestaurantEmployeeForm closeModal={closeModal} />
    </Modal>
  );
};
